import * as React from "react"

const IconVirtualRoom = (props) => (
  <svg
    width={32}
    height={32}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      d="M4.727.5A2.808 2.808 0 0 0 1.91 3.318v5.637a2.808 2.808 0 0 0 2.818 2.818H.5v2.818h16.91v-2.818h-4.228A2.808 2.808 0 0 0 16 8.955V3.318A2.808 2.808 0 0 0 13.182.5H4.727Zm0 2.818h8.455v5.637H4.727V3.318ZM3.318 17.41v9.864h9.864v-2.819H6.136V17.41H3.318Zm15.5 0A2.808 2.808 0 0 0 16 20.227v5.637a2.808 2.808 0 0 0 2.818 2.818h-4.227V31.5H31.5v-2.818h-4.227a2.808 2.808 0 0 0 2.818-2.818v-5.637a2.808 2.808 0 0 0-2.818-2.818h-8.455Zm0 2.818h8.455v5.637h-8.455v-5.637Z"
      fill="#1B1464"
    />
  </svg>
)

export default IconVirtualRoom
